// extracted by mini-css-extract-plugin
module.exports = {"Container":"OneColumnView-module--Container--K-V7g","Title":"OneColumnView-module--Title--3PatB","Subtitle":"OneColumnView-module--Subtitle--c2la5"};